/**
 * Seeded, serializable RNG (RFC §4: rng state lives IN the save so
 * determinism survives save/load). mulberry32 — tiny, fast, good-enough
 * distribution for game rolls; NOT cryptographic (doesn't need to be).
 */

export interface RngState {
  seed: number;
  /** Internal 32-bit counter state; advances per draw. */
  state: number;
}

export function newRngState(seed: number): RngState {
  if (!Number.isInteger(seed)) {
    throw new Error(`newRngState: seed must be an integer, got ${seed}`);
  }
  return { seed, state: seed >>> 0 };
}

/** Draw a float in [0, 1); mutates rng.state (the only mutation point). */
export function draw(rng: RngState): number {
  rng.state = (rng.state + 0x6d2b79f5) >>> 0;
  let t = rng.state;
  t = Math.imul(t ^ (t >>> 15), t | 1);
  t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
  return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
}

/** Integer in [0, n). */
export function drawInt(rng: RngState, n: number): number {
  if (!Number.isInteger(n) || n <= 0) {
    throw new Error(`drawInt: n must be an integer >= 1, got ${n}`);
  }
  return Math.floor(draw(rng) * n);
}
